import { z } from 'zod';
import { goDurationSchema, isValidGoDuration } from '../general/go-duration.ts';

export const punchyDelaySchema = goDurationSchema;

export const punchyDelayRequiredSchema = goDurationSchema.refine((val): val is string => val !== null && val !== '', {
  message: 'Please enter a duration, such as 100ms or 3s',
});

export const punchyDelayStrictSchema = z.custom<string>((val) => typeof val === 'string' && isValidGoDuration(val));
